import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Avboka',
  confirmation: 'Din tid är avbokad',
  button: 'Sök ny tid',
});
